<div class="relative p-3">
  <div>Emergency</div>
    <button (click)="cancel()" class="absolute top-2 right-4 p-2 bg-black/20 hover:bg-black/40 rounded-full text-white transition-colors">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
    </button>
</div>

<ion-row class="bg-white dark:bg-gray-800">

  

  <!-- <ion-col size="12">
    <ion-item lines="none">
      <ion-label slot="start">Emergency</ion-label>
      <ion-button slot="end" class="default" (click)="cancel()">Close</ion-button>
    </ion-item>
  </ion-col> -->
  <ion-col size="12" *ngIf="staff">
    <audio id="bgAudio" src="assets/emegency.mpeg" loop autoplay></audio>
    <p class="ion-text-center" style="background: var(--ion-color-danger); color: var(--ion-color-danger-contrast); padding: 10px; border-radius: 5px;">
      <ion-icon name="warning-outline"></ion-icon>
      {{ staff.fullName }} has triggered emergency. Please check his/her location on the map.
    </p>
    <div style="text-align: center; margin-top: 10px;">
      <img
        *ngIf="staff.selfiePhoto"
        src="{{ staff.selfiePhoto }}"
        style="width: 75px; height: 75px; border-radius: 50%;border: 1px solid #998d8d; margin: 0px auto;"
      />
      <img
        *ngIf="!staff.selfiePhoto"
        src="assets/avt/knight.jpg"
        style="width: 75px; height: 75px; border-radius: 50%;border: 1px solid #998d8d; margin: 0px auto;"
      />
      <p style="font-weight: bold; margin: 0;" class="text-gray-500 dark:text-gray-400">{{ staff.fullName }}</p>
      <p style="margin: 0;" class="text-gray-500 dark:text-gray-400">{{ staff.email }}</p>
    </div>
  </ion-col>
  <!-- <ion-col size="6" class="ion-text-left">
    <ion-button (click)="markAsDone()">Mark Done</ion-button>    
  </ion-col> -->
  <ion-col size="12" class="ion-text-right">
    <ion-button (click)="showDirection()"><ion-icon name="compass-outline"></ion-icon>&nbsp;Show Direction</ion-button>
  </ion-col>
  <ion-col size="12">
    <div [id]="uniqueId" style="height: 500px; width: 100%;"></div>
  </ion-col>
</ion-row>